import type { Event } from './types';

// TODO: These need to be sourced from the server/database
export const defaultDivisions = ['Novice', 'Intermediate', 'Advanced', 'All-Star', 'Champion'];
export const defaultRoles = ['Leader', 'Follower'];

export const defaultEvents: Record<string, Event> = {
  '1': {
    id: '1',
    name: 'West Coast Classic 2025',
    date: new Date('2025-01-15'),
    location: 'Los Angeles, CA',
    venueName: 'LA Convention Center',
    description:
      'Join us for the premier West Coast dance competition featuring top dancers from around the world. Multiple divisions and categories available.',
    registrationDeadline: new Date('2025-01-01'),
    registrationPrices: [
      { description: 'Early Bird (until Dec 1)', price: 75 },
      { description: 'Regular (Dec 2 - Jan 1)', price: 100 },
    ],
    website: 'https://westcoastclassic.com',
    isActive: true,
    isRegistered: false,
    eventImage: '',
    attendees: [],
    competitions: [],
    updateHistory: [],
    summary: '',
  },
  '2': {
    id: '2',
    name: 'Phoenix Dance Festival',
    date: new Date('Feb 22, 2025'),
    location: 'Phoenix, AZ',
    venueName: 'Phoenix Convention Center',
    isActive: true,
    isRegistered: false,
    description:
      'A three-day festival celebrating West Coast Swing with workshops, competitions, and social dancing every evening.',
    registrationDeadline: new Date('Feb 8, 2025'),
    registrationPrices: [{ description: 'General Admission', price: 85 }],
    competitions: [],
    updateHistory: [],
    attendees: [],
    eventImage: '',
    summary: '',
    website: 'https://phoenixdancefest.com',
  },
};
